import React from "react";
import GeneralStrings from "../../../strings/GeneralStrings.json";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { Field } from "formik";

const TimeStep = () => {
  const TIME_STEP_STRINGS = GeneralStrings.ENROLL.FORM_LABELS.TIME_STEP;

  return (
    <div className="step">
      <h4
        className="step-header"
        dangerouslySetInnerHTML={{
          __html: TIME_STEP_STRINGS.HEADER_HTML,
        }}
      />
      <div className="question-container">
        <FormGroup
          name="weekdayAvailabilityTime"
          className="form-group time-container"
        >
          <div className="weekday-time-container">
            <h5>Weekday:</h5>
            <Field
              type="checkbox"
              as={FormControlLabel}
              control={<Checkbox />}
              name="weekdayAvailabilityTime"
              label="6am - 8am"
              value="weekday_6am - 8am"
            />
            <Field
              type="checkbox"
              as={FormControlLabel}
              control={<Checkbox />}
              name="weekdayAvailabilityTime"
              label="8am - 10am"
              value="weekday_8am - 10am"
            />
            <Field
              type="checkbox"
              as={FormControlLabel}
              control={<Checkbox />}
              name="weekdayAvailabilityTime"
              label="10am - 12pm"
              value="weekday_10am - 12pm"
            />
            <Field
              type="checkbox"
              as={FormControlLabel}
              control={<Checkbox />}
              name="weekdayAvailabilityTime"
              label="12pm - 2pm"
              value="weekday_12pm - 2pm"
            />
            <Field
              type="checkbox"
              as={FormControlLabel}
              control={<Checkbox />}
              name="weekdayAvailabilityTime"
              label="2pm - 4pm"
              value="weekday_2pm - 4pm"
            />
            <Field
              type="checkbox"
              as={FormControlLabel}
              control={<Checkbox />}
              name="weekdayAvailabilityTime"
              label="7pm - 9pm"
              value="weekday_7pm - 9pm"
            />
          </div>
          <hr />
          <div className="weekend-time-container">
            <h5>Weekend:</h5>
            <Field
              type="checkbox"
              as={FormControlLabel}
              control={<Checkbox />}
              name="weekdayAvailabilityTime"
              label="8am - 10am (Saturday Only)"
              value="weekend_8am - 10am"
            />
            <Field
              type="checkbox"
              as={FormControlLabel}
              control={<Checkbox />}
              name="weekdayAvailabilityTime"
              label="10am - 12pm (Saturday Only)"
              value="weekend_10am - 12pm"
            />
            <Field
              type="checkbox"
              as={FormControlLabel}
              control={<Checkbox />}
              name="weekdayAvailabilityTime"
              label="12pm - 2pm"
              value="weekend_12pm - 2pm"
            />
            <Field
              type="checkbox"
              as={FormControlLabel}
              control={<Checkbox />}
              name="weekdayAvailabilityTime"
              label="2pm - 4pm"
              value="weekend_2pm - 4pm"
            />
            <Field
              type="checkbox"
              as={FormControlLabel}
              control={<Checkbox />}
              name="weekdayAvailabilityTime"
              label="4pm - 6pm"
              value="weekend_4pm - 6pm"
            />
            <Field
              type="checkbox"
              as={FormControlLabel}
              control={<Checkbox />}
              name="weekdayAvailabilityTime"
              label="6pm - 8pm"
              value="weekend_6pm - 8pm"
            />
          </div>
        </FormGroup>
      </div>
    </div>
  );
};

export default TimeStep;
